import * as React from 'react'
import { ReactElement } from 'react'
import { AppShell, Box, Center, createStyles, Header, Loader, Stack } from '@mantine/core'
import { User } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { Client } from '@ospace/schemas'
import { Notification } from '@ospace/shared'

import { useSideNav } from '../hooks/useSideNav'

import { CustomHeader } from './CustomHeader'
import { Footer } from './Footer'
import { PageId, SideNavbar } from './SideNavbar'

const useStyles = createStyles((theme) => ({
  main: {
    background: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
  },
  mainContainer: {
    margin: -12,
    height: '100%',
  },
  innerPage: {
    background: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
  },
}))

const EmptyHeader = (
  <Header height={0}>
    <></>
  </Header>
)

type Props =
  | {
      status: 'ready'
      pageId: PageId
      children: ReactElement
      user: User
      role: userTypes
      client: Client
      subHeader?: ReactElement
      pageTitle?: string
      fluid?: boolean
    }
  | {
      status: 'loading'
      pageId: PageId
      user?: User
      role: userTypes
      client?: Client
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
    }
  | {
      status: 'error'
      pageId: PageId
      user?: User
      role: userTypes
      client?: Client
      pageTitle?: string
      subHeader?: ReactElement
      fluid?: boolean
      message: string
    }

export const ClientPageLayout = (props: Props) => {
  const { classes } = useStyles()
  const { opened, setOpened } = useSideNav()

  return (
    <>
      <Notification />
      <AppShell
        className={classes.main}
        navbar={
          <SideNavbar
            activePageId={props.pageId}
            setOpened={setOpened}
            opened={opened}
            client={props.client}
            user={props.user}
            role={props.role}
          />
        }
        header={EmptyHeader}
      >
        <Stack justify='space-between' h='100%'>
          <div className={classes.mainContainer}>
            <CustomHeader
              user={props.user}
              role={props.role}
              client={props.client}
              subHeader={props.subHeader}
              pageTitle={props.pageTitle}
            />
            <Box className={classes.innerPage} maw={props.fluid ? '100%' : 1600} m='auto' p='xl'>
              {props.status === 'ready' ? props.children : null}
              {props.status === 'loading' ? (
                <Center maw='100vh' h='100vh' mx='auto'>
                  <Loader variant='bars' role='alert' aria-label='loading' />
                </Center>
              ) : null}
              {props.status === 'error' ? props.message : null}
            </Box>
          </div>
          <Footer />
        </Stack>
      </AppShell>
    </>
  )
}
